document.addEventListener('DOMContentLoaded', () => {
  const guideEl = document.getElementById('sizeGuide');
  if (!guideEl) return;

  const html = document.documentElement;
  const body = document.body;
  const panelEl = guideEl.querySelector('.size-guide__panel');

  const openGuide = () => {
    guideEl.classList.add('active');

    // scroll lock (werkt op meeste themes/browsers) - zelfde patroon als
    // Dawn's eigen modals (product-modal.js, cart-drawer.js), die geen
    // touch-action gebruiken.
    html.classList.add('overflow-hidden');
    body.classList.add('overflow-hidden');

    // Bugfix 2026-09-06 (Samsung S24 Ultra, gemelde scroll-lock-bug):
    // `body.style.touchAction = 'none'` stond hier eerder als extra iOS-
    // veiligheidsmaatregel, maar touch-action combineert via een
    // "intersectie" over de hele ouder-keten - een `none` op <body>
    // overschrijft/blokkeert ELKE touch-scroll binnen de modal-inhoud,
    // ook binnen de nu wel scrollbare `.size-guide__panel` (zie de CSS-
    // fix hieronder), en kan door een onderliggend element niet meer
    // "teruggezet" worden. Dawn's eigen modals (product-modal.js,
    // cart-drawer.js) gebruiken dit nergens en gebruiken uitsluitend de
    // overflow-hidden-klassen hierboven om achtergrondscroll te blokkeren
    // - dat bewezen patroon is hier nu ook gevolgd, de touch-action-regel
    // is verwijderd.
    if (panelEl) panelEl.scrollTop = 0;

    // Bugfix 2026-09-06: reset de maat-calculator-status telkens als de modal
    // opnieuw opent, zodat een eerdere foutmelding/resultaat (van een vorig
    // bezoek aan de modal, binnen dezelfde paginaweergave) niet blijft hangen.
    // De invoervelden zelf worden hier bewust NIET geleegd (dat gedrag was al
    // correct, ongewijzigd gelaten).
    const calcError = document.getElementById('sizeCalcError');
    if (calcError) calcError.hidden = true;

    const calcResult = document.getElementById('sizeCalcResult');
    if (calcResult) calcResult.hidden = true;

    document
      .querySelectorAll('.size-guide__table-row--recommended')
      .forEach((row) => row.classList.remove('size-guide__table-row--recommended'));
  };

  const closeGuide = () => {
    guideEl.classList.remove('active');

    // altijd unlocken
    html.classList.remove('overflow-hidden');
    body.classList.remove('overflow-hidden');
  };

  // 1) Open via trigger
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.size-guide-trigger');
    if (!trigger) return;

    e.preventDefault();
    openGuide();
  });

  // 2) Close via overlay / X / rode knop (of elk element met data-close)
  guideEl.addEventListener('click', (e) => {
    // overlay click
    if (e.target.classList.contains('size-guide__overlay')) {
      closeGuide();
      return;
    }

    // close buttons
    if (e.target.closest('.size-guide__close') || e.target.closest('[data-size-guide-close]')) {
      e.preventDefault();
      closeGuide();
    }
  });

  // 3) Escape sluit
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (!guideEl.classList.contains('active')) return;
    closeGuide();
  });
});
